// extracted by mini-css-extract-plugin
export default {"cls1":"Truncate-cls1_En4","cls2":"Truncate-cls2_RuS Truncate-cls1_En4"};